export default {
	title: 'Biblioteca de Engranajes',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Datos de Engranajes',
		description: 'No se encontraron datos de engranajes'
	},
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		name: 'Nombre del Engranaje',
		type: 'Tipo de Engranaje',
		module: 'Módulo',
		teethNumber: 'Número de Dientes',
		pressureAngle: 'Ángulo de Presión',
		material: 'Material',
		placeholder: {
			name: 'Por favor ingrese el nombre del engranaje',
			type: 'Por favor ingrese el tipo de engranaje',
			module: 'Por favor ingrese el módulo',
			teethNumber: 'Por favor ingrese el número de dientes',
			pressureAngle: 'Por favor ingrese el ángulo de presión',
			material: 'Por favor ingrese el material'
		}
	},
	table: {
		name: 'Nombre del Engranaje',
		type: 'Tipo de Engranaje',
		module: 'Módulo',
		teethNumber: 'Número de Dientes',
		pressureAngle: 'Ángulo de Presión',
		material: 'Material'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	}
}
